/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '@services/language/language.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ApiSysEventsService {
  private url;

  private get language(): string {
    return this.langService.getLanguage().toLowerCase();
  }

  constructor(
    private http: HttpClient,
    public langService: LanguageService,
    private authService: AuthService
  ) {
    this.url = environment.url_events_api;
  }

  private get authHeaders(): HttpHeaders {
    return new HttpHeaders().set("Authorization", `Bearer ${this.authService.getToken()}`);
  }

  // Notifications
  getNotifications(): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(`${this.url}/notifroutes/getNotifications/${this.language}`, { headers });
  }

  changeNotificationStatusDone(notificationId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.patch(`${this.url}/notifroutes/movetodone/${notificationId}`, {}, { headers });
  }

  changeNotificationStatusInbox(notificationId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.patch(`${this.url}/notifroutes/movetoinbox/${notificationId}`, {}, { headers });
  }

  deleteNotification(notificationId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.delete(`${this.url}/notifroutes/deleteNotification/${notificationId}`, { headers });
  }

  getPersonnelCreationStatus(correlationId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(`${this.url}/status/${correlationId}`, { headers });
  }

  getPersonnelCreationHistory(correlationId: string): Observable<any> {
    const headers = this.authHeaders;
    return this.http.get(`${this.url}/history/${correlationId}`, { headers });
  }
}
